import * as echarts from 'echarts';
import { GaugeChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { BaseChartComponent } from './base-chart.component';
import { EChartsType } from 'echarts/core';

echarts.use([GaugeChart, CanvasRenderer] as any);

export class RsiGaugeChartComponent extends BaseChartComponent {
    name!: string;
    value!: number;

    $onChanges() {
        this.chart && this.initializeChart(this.chart);
    }

    whenDataReady(): Promise<boolean> {
        return Promise.resolve(true);
    }

    initializeChart(chart: EChartsType): void {
        chart.setOption({
            series: [
                {
                    type: 'gauge',
                    startAngle: 180,
                    endAngle: 0,
                    min: 0,
                    max: 100,
                    splitNumber: 8,
                    axisLine: {
                        lineStyle: {
                            width: 20,
                            color: [
                                [1 / 3, '#d43f47'],
                                [2 / 3, '#FFED38'],
                                [1, '#33bf1a'],
                            ],
                        },
                    },
                    axisTick: {
                        length: 0,
                        lineStyle: {
                            color: 'auto',
                            width: 2,
                        },
                    },
                    splitLine: {
                        length: 0,
                        lineStyle: {
                            color: 'auto',
                            width: 5,
                        },
                    },
                    axisLabel: {
                        color: '#464646',
                        fontSize: 20,
                        distance: -60,
                        formatter: function (value: number) {
                            if (value === 12.5) {
                                return '   0%';
                            } else if (value === 87.5) {
                                return '100%';
                            }
                            return '';
                        },
                    },
                    title: {
                        offsetCenter: [0, 60],
                        fontSize: 30,
                    },
                    detail: {
                        offsetCenter: [0, 30],
                        valueAnimation: true,
                        color: '#000',
                    },
                    data: [
                        {
                            value: this.value,
                            name: this.name,
                        },
                    ],
                },
            ],
        });
    }

    get tooltipText() {
        return `
            <div>Daily RSI(14) value.</div>
            <div>100% → overbought.</div>
            <div>0% → oversold.</div>
        `;
    }
}

angular.module('tradersyard').component('tyRsiGaugeChart', {
    // language=HTML
    template: `
        <div class="chart target_chart_element"
             uib-tooltip-html="$ctrl.tooltipText"
             tooltip-placement="top"
             tooltip-append-to-body="false"
             tooltip-class="gauge_tooltip"
        ></div>
    `,
    controller: RsiGaugeChartComponent,
    bindings: {
        name: '<',
        value: '<',
    },
});
